import { futureValueSIP } from "../../engine/calculations";

const stepUpSipConfig = {
  key: "step-up-sip-future-value",
  title: "Step-Up SIP Future Value",
  category: "Growth",
  description: "Model a SIP where your monthly contribution rises every year.",
  fields: [
    { key: "startMonthly", label: "Starting monthly SIP", type: "currency", default: 10_000, min: 500, max: 10_00_000 },
    { key: "stepUpPct", label: "Annual step-up", type: "percent", default: 10, min: 1, max: 50, help: "How much the monthly SIP rises each year." },
    { key: "returnRate", label: "Expected annual return", type: "percent", default: 12, min: 1, max: 30, assumptionKey: "equityReturn" },
    { key: "years", label: "Investment period (years)", type: "number", default: 15, min: 1, max: 40 },
  ],
  chart: {
    type: "line",
    xKey: "year",
    series: [
      { key: "invested", label: "Invested", colorVar: "--muted" },
      { key: "value", label: "Value", colorVar: "--gold" },
    ],
  },
  compute(values) {
    const startMonthly = Number(values.startMonthly) || 0;
    const stepUpPct = (Number(values.stepUpPct) || 0) / 100;
    const annualRate = (Number(values.returnRate) || 0) / 100;
    const years = Number(values.years) || 0;

    const series = [];
    let balance = 0;
    let monthly = startMonthly;
    let invested = 0;
    for (let y = 1; y <= years; y++) {
      const yearContrib = futureValueSIP(monthly, annualRate, 12);
      balance = balance * (1 + annualRate) + yearContrib;
      invested += monthly * 12;
      series.push({ year: y, invested, value: balance });
      monthly = monthly * (1 + stepUpPct);
    }

    const futureValue = balance;
    const totalInvested = invested;

    return {
      headline: { label: "Future Value", value: futureValue },
      breakdown: [
        { label: "Total Invested", value: totalInvested },
        { label: "Estimated Gains", value: futureValue - totalInvested },
      ],
      series,
    };
  },
};

export default stepUpSipConfig;
